<script>
import { mapActions } from 'vuex';
import SustainfinityTable from '../../../../components/SustainfinityTable.vue';

export default {
    components: {
        SustainfinityTable,
    },

    data() {
        return {
            items: [
                {
                    name: 'sector',
                    methods: {
                        get: 'getSector',
                        create: 'createSector',
                        update: 'updateSector',
                        delete: 'deleteSector',
                    },
                    additional_cols: [],
                    parent: null,
                    iterators: {
                        self: 'sust_sector',
                        parent: null,
                    },
                },
                {
                    name: 'category',
                    methods: {
                        get: 'getCategory',
                        create: 'createCategory',
                        update: 'updateCategory',
                        delete: 'deleteCategory',
                    },
                    additional_cols: [ // is update only, no create
                        {
                            key: 'objective',
                            text: 'Objective',
                        },
                        {
                            key: 'objective_tr',
                            text: 'Objective (TR)',
                        },
                        {
                            key: 'egv',
                            text: 'EGV',
                        },
                        {
                            key: 'egv_tr',
                            text: 'EGV (TR)',
                        },
                    ],
                    parent: null,
                    iterators: {
                        self: 'sust_category',
                        parent: null,
                    },
                },
                {
                    name: 'element',
                    methods: {
                        get: 'getElement',
                        create: 'createElement',
                        update: 'updateElement',
                        delete: 'deleteElement',
                    },
                    additional_cols: [],
                    parent: 'category',
                    iterators: {
                        self: 'sust_element',
                        parent: 'sust_category',
                    },
                },
                {
                    name: 'target_area',
                    methods: {
                        get: 'getTargetArea',
                        create: 'createTargetArea',
                        update: 'updateTargetArea',
                        delete: 'deleteTargetArea',
                    },
                    additional_cols: [],
                    parent: 'element',
                    iterators: {
                        self: 'sust_target_area',
                        parent: 'sust_element',
                    },
                },
                {
                    name: 'target',
                    methods: {
                        get: 'getTarget',
                        create: 'createTarget',
                        update: 'updateTarget',
                        delete: 'deleteTarget',
                    },
                    additional_cols: [],
                    parent: 'target_area',
                    iterators: {
                        self: 'sust_target',
                        parent: 'sust_target_area',
                    },
                },
                {
                    name: 'kpi',
                    methods: {
                        get: 'getKPI',
                        create: 'createKPI',
                        update: 'updateKPI',
                        delete: 'deleteKPI',
                    },
                    additional_cols: [],
                    parent: 'target',
                    iterators: {
                        self: 'sust_kpi',
                        parent: 'sust_target',
                    },
                },
                {
                    name: 'metric',
                    methods: {
                        get: 'getMetric',
                        create: 'createMetric',
                        update: 'updateMetric',
                        delete: 'deleteMetric',
                    },
                    additional_cols: [],
                    parent: 'kpi',
                    iterators: {
                        self: 'sust_metric_kpi',
                        parent: 'sust_kpi',
                    },
                },
                {
                    name: 'sub_metric',
                    methods: {
                        get: 'getSubMetric',
                        create: 'createSubMetric',
                        update: 'updateSubMetric',
                        delete: 'deleteSubMetric',
                    },
                    additional_cols: [],
                    parent: 'metric',
                    iterators: {
                        self: 'sust_sub_metric_kpi',
                        parent: 'sust_metric_kpi',
                    },
                },
                {
                    name: 'global_goal',
                    methods: {
                        get: 'getGlobalGoals',
                        create: 'createGlobalGoals',
                        update: 'updateGlobalGoals',
                        delete: 'deleteGlobalGoals',
                    },
                    additional_cols: [],
                    parent: null,
                    iterators: {
                        self: 'su1_global_goal',
                        parent: null,
                    },
                },
                {
                    name: 'sub_goal',
                    methods: {
                        get: 'getSubGoals',
                        create: 'createSubGoals',
                        update: 'updateSubGoals',
                        delete: 'deleteSubGoals',
                    },
                    additional_cols: [],
                    parent: 'global_goal',
                    iterators: {
                        self: 'su1_sub_goal',
                        parent: 'su1_global_goal',
                    },
                },
                {
                    name: 'green_deal',
                    methods: {
                        get: 'getGreenDeals',
                        create: 'createGreenDeals',
                        update: 'updateGreenDeals',
                        delete: 'deleteGreenDeals',
                    },
                    additional_cols: [],
                    parent: null,
                    iterators: {
                        self: 'su1_green_deal',
                        parent: null,
                    },
                },
            ],

            table_items: [],
            table_parent_items: [],

            tableItemToCreate: {},
            tableItemToUpdate: {},

            excelFile: null,

            loading: false,
        }
    },

    computed: {
        item() {
            return this.$route.query.item;
        },

        selectedSustItem() {
            const selected = this.items.find(x => x.name === this.item);
            if (selected) {
                return selected;
            } else {
                return null;
            }
        },

        parentGetRequest() {
            if (this.selectedSustItem) {
                if (this.selectedSustItem.parent === null) {
                    return null;
                } else {
                    const parent = this.items.find(x => x.name === this.selectedSustItem.parent);
                    if (parent) {
                        return parent.methods.get;
                    } else {
                        return null;
                    }
                }
            } else {
                return null;
            }
        },

        headers() {
            if (this.parentGetRequest) {
                return [
                    {
                        key: `${this.selectedSustItem.iterators.self}_name`,
                        label: 'Name',
                        width: 2,
                    },
                    {
                        key: `${this.selectedSustItem.iterators.self}_name_tr`,
                        label: 'Name (TR)',
                        width: 2,
                    },
                    {
                        key: `${this.selectedSustItem.iterators.self}_description`,
                        label: 'Description',
                        width: 3,
                    },
                    {
                        key: `${this.selectedSustItem.iterators.self}_description_tr`,
                        label: 'Description (TR)',
                        width: 3,
                    },
                    {
                        key: `${this.selectedSustItem.iterators.parent}_name`,
                        label: `${this.capitalizeWord(this.selectedSustItem.parent)}`,
                        width: 2,
                    },
                    {
                        key: `created_on`,
                        label: 'Created Date',
                        width: 2,
                    },
                    {
                        key: `edit`,
                        label: 'Edit',
                        width: 1,
                    },
                    {
                        key: `delete`,
                        label: 'Delete',
                        width: 1,
                    },
                ];
            } else {
                return [
                    {
                        key: `${this.selectedSustItem.iterators.self}_name`,
                        label: 'Name',
                        width: 2,
                    },
                    {
                        key: `${this.selectedSustItem.iterators.self}_name_tr`,
                        label: 'Name (TR)',
                        width: 2,
                    },
                    {
                        key: `${this.selectedSustItem.iterators.self}_description`,
                        label: 'Description',
                        width: 3,
                    },
                    {
                        key: `${this.selectedSustItem.iterators.self}_description_tr`,
                        label: 'Description (TR)',
                        width: 3,
                    },
                    {
                        key: `created_on`,
                        label: 'Created Date',
                        width: 2,
                    },
                    {
                        key: `edit`,
                        label: 'Edit',
                        width: 1,
                    },
                    {
                        key: `delete`,
                        label: 'Delete',
                        width: 1,
                    },
                ];
            }
        },
    },

    watch: {
        selectedSustItem(val) {
            this.setupTable(val);
        }
    },

    mounted() {
        this.setupTable(this.items.find(x => x.name === this.item));
    },

    methods: {
        ...mapActions('additionalsettings', [
            'downloadSampleExcel',
            'bulkSustTable',
        ]),

        setupTable(item) {
            const payload = {
                created_by: this.$user.user_id,
                is_deleted: false,
            }

            this.loading = true;
            this.$store.dispatch(`additionalsettings/${item.methods.get}`, payload)
                .then(res => {
                    this.table_items = res.data;
                })
                .catch(error => {
                    console.error(error);
                })
            
            if (this.parentGetRequest) {
                this.$store.dispatch(`additionalsettings/${this.parentGetRequest}`, payload)
                    .then(res => {
                        this.table_parent_items = res.data;
                    })
                    .catch(error => {
                        console.error(error);
                    })
            }

            this.loading = false;
        },

        //#region Popup controllers

        clickItem(e) {
            if (e) {
                if (!e.event) {
                    console.error('No event data emitted from the table!');  
                } else if (e.event === 'edit') {
                    this.openUpdatePopup(e.item);
                } else if (e.event === 'delete') {
                    this.openDeletePopup(e.item);
                } else {
                    console.error('Invalid event emitted from the table: ', e.event);
                }
            } else {
                console.error('No event data emitted from the table!');
            }
        },

        openCreatePopup() {
            const self = this.selectedSustItem.iterators.self;
            if (this.parentGetRequest) {
                const parent = this.selectedSustItem.iterators.parent;

                this.tableItemToCreate[`${self}_name`] = "";
                this.tableItemToCreate[`${self}_name_tr`] = "";
                this.tableItemToCreate[`${self}_description`] = "";
                this.tableItemToCreate[`${self}_description_tr`] = "";
                this.tableItemToCreate[`${parent}_id`] = null;
            } else {
                this.tableItemToCreate[`${self}_name`] = "";
                this.tableItemToCreate[`${self}_name_tr`] = "";
                this.tableItemToCreate[`${self}_description`] = "";
                this.tableItemToCreate[`${self}_description_tr`] = "";
            }

            this.$refs.createPopup.openPopup();
        },

        createOk() {
            this.loading = true;

            let payload = {};
            const self = this.selectedSustItem.iterators.self;
            const parent = this.selectedSustItem.iterators.parent;
            if (this.parentGetRequest) {
                payload = {
                    [`${self}_name`]: this.tableItemToCreate[`${self}_name`],
                    [`${self}_name_tr`]: this.tableItemToCreate[`${self}_name_tr`],
                    [`${self}_description`]: this.tableItemToCreate[`${self}_description`],
                    [`${self}_description_tr`]: this.tableItemToCreate[`${self}_description_tr`],
                    [`${parent === 'sust_category' ? 'sust_element_category' : parent}_id`]: this.tableItemToCreate[`${parent}_id`],
                    created_by: this.$user.user_id,
                }
            } else {
                payload = {
                    [`${self}_name`]: this.tableItemToCreate[`${self}_name`],
                    [`${self}_name_tr`]: this.tableItemToCreate[`${self}_name_tr`],
                    [`${self}_description`]: this.tableItemToCreate[`${self}_description`],
                    [`${self}_description_tr`]: this.tableItemToCreate[`${self}_description_tr`],
                    created_by: this.$user.user_id,
                }
            }

            if (this.item === 'green_deal') {
                payload['su1_green_deal_id'] = this.table_items[this.table_items.length-1].su1_green_deal_id + 1;
            } else if (this.item === 'sub_goal') {
                payload['su1_sub_goal_id'] = this.table_items[this.table_items.length-1].su1_sub_goal_id + 1;
            } 

            this.$store.dispatch(`additionalsettings/${this.selectedSustItem.methods.create}`, payload)
                .then((res) => {
                    if (this.parentGetRequest) {
                        const parent_id = `${parent === 'sust_category' ? 'sust_element_category' : parent}_id`
                        this.table_items.unshift(
                            {
                                ...payload,
                                [`${this.selectedSustItem.iterators.parent}_name`]: this.table_parent_items.find(x => payload[parent_id] === x[`${parent}_id`])[`${parent}_name`],
                                created_on: new Date(),
                                [`${self}_id`]: res.data[`${self}_id`]
                            }
                        );
                    } else {
                        this.table_items.unshift(
                            {
                                ...payload,
                                created_on: new Date(),
                                [`${self}_id`]: res.data[`${self}_id`]
                            }
                        );
                    }

                    this.$notify('success', res.data.messageName);
                })
                .catch(({ response }) => {
                    this.$notify('error', response.data.messageName);
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        resetCreate() {
            this.tableItemToCreate = {};
        },

        openUpdatePopup(item) {
            this.tableItemToUpdate = {...item};
            this.$refs.updatePopup.openPopup();
        },

        updateOk() {
            this.loading = true;

            const self = this.selectedSustItem.iterators.self;
            let payload = {};

            for (const key in this.tableItemToUpdate) {
                if (Object.prototype.hasOwnProperty.call(this.tableItemToUpdate, key)) {
                    payload[key] = this.tableItemToUpdate[key];
                }
            }

            if (this.item === 'element') {
                payload.sust_element_category_id = payload.sust_category_id;
            }

            payload.created_by = this.$user.user_id;
            payload.updated_by = this.$user.user_id;

            this.$store.dispatch(`additionalsettings/${this.selectedSustItem.methods.update}`, payload)
                .then((res) => {
                    // TODO: mechanism to update parent real time
                    const idx = this.table_items.findIndex(x => x[`${self}_id`] === this.tableItemToUpdate[`${self}_id`]);
                    if (idx !== -1) {
                        this.table_items[idx] = this.tableItemToUpdate;
                    }

                    this.$notify('success', res.data.messageName);
                })
                .catch(({ response }) => {
                    this.$notify('error', response.data.messageName);
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        resetUpdate() {
            this.tableItemToUpdate = {};
        },

        openDeletePopup(item) {
            this.tableItemToUpdate = item;
            this.$refs.deletePopup.openPopup();
        },

        deleteOk() {
            this.loading = true;

            const self = this.selectedSustItem.iterators.self;
            let payload = {
                [`${this.selectedSustItem.iterators.self}_id`]: this.tableItemToUpdate[`${self}_id`],
                created_by: this.$user.user_id,
                deleted_by: this.$user.user_id,
            };

            this.$store.dispatch(`additionalsettings/${this.selectedSustItem.methods.delete}`, payload)
                .then((res) => {
                    this.table_items = this.table_items.filter(x => x[`${self}_id`] != this.tableItemToUpdate[`${self}_id`]);
                    this.$notify('success', res.data.messageName);
                })
                .catch(({ response }) => {
                    this.$notify('error', response.data.messageName);
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        resetDelete() {
            this.tableItemToUpdate = {};
        },

        //#endregion

        //#region Bulk Update 

        onFilePicked(e) {
            this.excelFile = e.target.files[0];
        },

        postBulkFile() {
            let formData = new FormData();
            formData.append("files", this.excelFile);
            formData.append("created_by",  this.$user.user_id);
            formData.append("table_name", "element");
            this.bulkSustTable(formData)
                .then((response) => {
                    this.$notify('success', response.data.messageName);
                })
                .catch(({ response }) => {
                    this.$notify('error', response.data.messageName);
                });
        },

        //#endregion

        //#region Utility

        capitalizeWord(word) {
            let arr = word.split('');
            arr = arr.map(x => x === '_' ? ' ' : x);
            arr[0] = arr[0].toUpperCase();
            return arr.join('');
        },

        //#endregion
    }
}
</script>

<template>
    <div>
        <div
            style="
                display: flex;
                flex-direction: row;
                justify-content: flex-end;
                align-items: center;
                padding-bottom: 1em;
            "
        >
            <button
                @click="openCreatePopup()"
                class="sust-btn sust-btn-green"
                style="margin-left: .5em;"
            >
                {{ $t("additionalSettings.general.create_header") }}
            </button>
            <button
                @click="() => $refs.bulkPopup.openPopup()"
                class="sust-btn sust-btn-blue"
                style="margin-left: .5em;"
            >
                {{ $t("additionalSettings.general.create_bulk") }}
            </button>
        </div>

        <sustainfinity-table 
            :headers="headers" 
            :items="table_items" 
            :iterator="selectedSustItem.iterators.self.concat('_id')" 
            :loading="loading"
            @btnClick="clickItem($event)"
        />

        <sust-popup
            ref="createPopup"
            :title="$t('additionalSettings.general.create_header')"
            @ok="createOk()"
            @onHide="resetCreate()"
            size="lg"
        >
            <form ref="form" class="additional-settings-popup-body" v-if="tableItemToCreate">
                <div
                    class="half-size"
                >
                    <label for="input">
                        Name
                    </label>
                    <input 
                        name="input"
                        type="text"
                        maxlength="1000"
                        v-model="tableItemToCreate[`${selectedSustItem.iterators.self}_name`]"
                        required
                    >
                </div>
                
                <div
                    class="half-size"
                >
                    <label for="input">
                        Name (TR)
                    </label>
                    <input 
                        name="input"
                        type="text"
                        maxlength="1000"
                        required
                        v-model="tableItemToCreate[`${selectedSustItem.iterators.self}_name_tr`]"
                    >
                </div>
                
                <div
                    v-if="parentGetRequest"
                    class="full-size"
                >
                    <label for="input">
                        {{ capitalizeWord(selectedSustItem.parent) }}
                    </label>
                    <select 
                        name="input"
                        required
                        v-model="tableItemToCreate[`${selectedSustItem.iterators.parent}_id`]"
                    >
                        <option 
                            v-for="_item in table_parent_items"
                            :key="_item[`${selectedSustItem.iterators.parent}_id`]"
                            :value="_item[`${selectedSustItem.iterators.parent}_id`]"
                        >
                            {{ _item[`${selectedSustItem.iterators.parent}_name`] }}
                        </option>
                    </select>
                </div>
                
                <div
                    class="full-size"
                >
                    <label for="input">
                        Description
                    </label>
                    <textarea 
                        name="input"
                        maxlength="2000"
                        rows="3"
                        required
                        v-model="tableItemToCreate[`${selectedSustItem.iterators.self}_description`]"
                    ></textarea>
                </div>
                
                <div
                    class="full-size"
                >
                    <label for="input">
                        Description (TR)
                    </label>
                    <textarea 
                        name="input"
                        maxlength="2000"
                        rows="3"
                        required
                        v-model="tableItemToCreate[`${selectedSustItem.iterators.self}_description_tr`]"
                    ></textarea>
                </div>
            </form>
        </sust-popup>

        <sust-popup
            ref="updatePopup"
            :title="$t('additionalSettings.general.update_header')"
            @ok="updateOk()"
            @onHide="resetCreate()"
            size="lg"
        >
            <form ref="form" class="additional-settings-popup-body" v-if="tableItemToUpdate">
                <div
                    class="half-size"
                >
                    <label for="input">
                        Name
                    </label>
                    <input 
                        name="input"
                        type="text"
                        maxlength="1000"
                        v-model="tableItemToUpdate[`${selectedSustItem.iterators.self}_name`]"
                        required
                    >
                </div>
                
                <div
                    class="half-size"
                >
                    <label for="input">
                        Name (TR)
                    </label>
                    <input 
                        name="input"
                        type="text"
                        maxlength="1000"
                        required
                        v-model="tableItemToUpdate[`${selectedSustItem.iterators.self}_name_tr`]"
                    >
                </div>
                
                <div
                    v-if="parentGetRequest"
                    class="full-size"
                >
                    <label for="input">
                        {{ capitalizeWord(selectedSustItem.parent) }}
                    </label>
                    <select 
                        name="input"
                        required
                        v-model="tableItemToUpdate[`${selectedSustItem.iterators.parent}_id`]"
                    >
                        <option 
                            v-for="_item in table_parent_items"
                            :key="_item[`${selectedSustItem.iterators.parent}_id`]"
                            :value="_item[`${selectedSustItem.iterators.parent}_id`]"
                        >
                            {{ _item[`${selectedSustItem.iterators.parent}_name`] }}
                        </option>
                    </select>
                </div>
                
                <div
                    class="full-size"
                >
                    <label for="input">
                        Description
                    </label>
                    <textarea 
                        name="input"
                        maxlength="2000"
                        rows="3"
                        required
                        v-model="tableItemToUpdate[`${selectedSustItem.iterators.self}_description`]"
                    ></textarea>
                </div>
                
                <div
                    class="full-size"
                >
                    <label for="input">
                        Description (TR)
                    </label>
                    <textarea 
                        name="input"
                        maxlength="2000"
                        rows="3"
                        required
                        v-model="tableItemToUpdate[`${selectedSustItem.iterators.self}_description_tr`]"
                    ></textarea>
                </div>

                <div
                    class="full-size"
                    v-for="col in selectedSustItem.additional_cols"
                    :key="col.key"
                >
                    <label for="input">
                        {{ col.text }}
                    </label>
                    <textarea 
                        name="input"
                        maxlength="3000"
                        rows="3"
                        required
                        v-model="tableItemToUpdate[col.key]"
                    ></textarea>
                </div>
            </form>
        </sust-popup>

        <sust-popup
            ref="deletePopup"
            :title="$t('additionalSettings.general.delete_header')"
            @ok="deleteOk()"
            @onHide="resetDelete()"
            size="sm"
        >
            <div class="additional-settings-popup-body">
                {{ $t("additionalSettings.element.deleteTitle") }}
            </div>
        </sust-popup>

        <sust-popup
            ref="bulkPopup"
            :title="$t('additionalSettings.general.create_bulk')"
            @ok="postBulkFile()"
            size="md"
        >
            <div class="additional-settings-popup-body">
                <div class="full-size">
                <input 
                    ref="fileInput"
                    name="input"
                    type="file"
                    accept=".xls,.xlsx"
                    @change="onFilePicked"
                    hidden
                >
                <button class="file-input-label" v-if="!excelFile"
                    @click="() => $refs.fileInput.click()"
                >
                    {{ $t('createUser.selectFile') }}
                </button>
                <button class="file-input-label" v-else
                    @click="() => $refs.fileInput.click()"
                >
                    {{ excelFile.name }}
                </button>
                </div>

                <div class="full-size">
                <button
                    class="sust-btn sust-btn-green"
                    @click="downloadSampleExcel(item.concat('_example'))"
                >
                    {{ $t("registerForm.buttonTitles.sampleExcel") }}
                </button>
                </div>
            </div>
        </sust-popup>
    </div>
</template>

<style lang='scss' scoped>

</style>